import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, mergeProps as _mergeProps, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8f48fa9c")

_pushScopeId("data-v-8f48fa9c")
const _hoisted_1 = {
  key: 0,
  id: "sidebar",
  style: {"z-index":"999"},
  role: "dialog",
  class: "modal",
  "aria-modal": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center h-100 justify-content-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_error = _resolveComponent("error")!

  return (_openBlock(), _createBlock(_Teleport, {
    to: "body",
    disabled: !_ctx.mounted
  }, [
    (_ctx.mounted)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_Transition, {
            name: "sidebar-backdrop-anim",
            appear: ""
          }, {
            default: _withId(() => [
              (_ctx.isShow)
                ? (_openBlock(), _createBlock("div", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onHiding && _ctx.onHiding(...args))),
                    class: "sidebar-modal-backdrop"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "sidebar-anim" }, {
            default: _withId(() => [
              (_ctx.isShow)
                ? (_openBlock(), _createBlock("div", _mergeProps({
                    key: 0,
                    id: "sidebar-body"
                  }, _ctx.$attrs, { class: "container container-fluid p-0 m-0 bg-white h-100 sidebar-modal" }), [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock("div", _hoisted_2, [
                          _createVNode(_component_spinner)
                        ]))
                      : (_ctx.error)
                        ? (_openBlock(), _createBlock(_component_error, {
                            key: 1,
                            error: _ctx.error
                          }, null, 8, ["error"]))
                        : _renderSlot(_ctx.$slots, "default", { key: 2 }, undefined, true)
                  ], 16))
                : _createCommentVNode("", true)
            ]),
            _: 3
          })
        ]))
      : _createCommentVNode("", true)
  ], 8, ["disabled"]))
})